// Wall-clock duration per turn: max(streamingEndTime) − min(initiatedAt) across
// the turn's assistant messages, keyed by turnId (joined via the same
// message-id → turnId map normalizeMessages uses). `timing` rides on the raw
// AviatorChirpMessage for both live (settled) and persisted messages, so this
// works identically in either case. Turns with no settled message (no
// streamingEndTime yet) are omitted, so an in-progress turn simply has no entry
// until it settles.
export function computeTurnDurationsMs(rawMessages, turnIdMap) {
  const durations = new Map();
  if (!turnIdMap) return durations;
  const minStart = new Map();
  const maxEnd = new Map();
  for (const message of rawMessages) {
    var _message$timing, _message$timing2;
    if (message.role !== 'ASSISTANT') continue;
    const turnId = turnIdMap.get(message.id);
    if (turnId === undefined) continue;
    const start = (_message$timing = message.timing) === null || _message$timing === void 0 ? void 0 : _message$timing.initiatedAt;
    if (typeof start === 'number') {
      const prevStart = minStart.get(turnId);
      if (prevStart === undefined || start < prevStart) {
        minStart.set(turnId, start);
      }
    }
    const end = (_message$timing2 = message.timing) === null || _message$timing2 === void 0 ? void 0 : _message$timing2.streamingEndTime;
    if (typeof end === 'number') {
      const prevEnd = maxEnd.get(turnId);
      if (prevEnd === undefined || end > prevEnd) {
        maxEnd.set(turnId, end);
      }
    }
  }
  for (const [turnId, end] of maxEnd) {
    const start = minStart.get(turnId);
    if (start === undefined) continue;
    // Clamp rather than drop: a completed-but-clock-skewed turn (end < start)
    // still gets an entry (0) so it stays distinguishable from an in-progress
    // turn, which has no streamingEndTime and thus no entry at all.
    durations.set(turnId, Math.max(0, end - start));
  }
  return durations;
}